module.exports = function() {
	var home = document.querySelector('.home');
	var menuItems = document.querySelectorAll('.menu--main > .menu__items > .menu__item');

	if(!home) {
		return;
	}

	var overlayed, curIdx;

	function onOver(i, evt) {
		if(curIdx !== i) {
			overlayed = !!evt.target.querySelector('.icon--dropdown');

			if(overlayed) {
				home.classList.add('st-overlayed');
			} else {
				home.classList.remove('st-overlayed');
			}

			curIdx = i;
		}
	}

	function onOut(i, evt) {
		curIdx = null
		overlayed = false;
		home.classList.remove('st-overlayed');
	}

	var i = 0, max = menuItems.length;
	for(;i < max; i += 1) {
		menuItems[i].addEventListener('mouseenter', onOver.bind(menuItems[i], i));
		menuItems[i].addEventListener('mouseleave', onOut.bind(menuItems[i], i));
	}
};


/** WEBPACK FOOTER **
 ** ./src/scripts/lib/home.js
 **/